import { FC } from 'react';

import { Flex } from '@servicetitan/anvil2';

import { TelecomBrandData } from '../api/telecom.api';
import { getTelecomBrandStatusDisplayName } from '../utils/enum-display.utils';
import { formatTelecomDateWithTimezone } from '../utils/date-format';
import { SectionCard } from './section-card';
import { LabelText, FieldText } from '../components/text-components';

interface StatusCardProps {
    brand: TelecomBrandData;
}

export const StatusCard: FC<StatusCardProps> = ({ brand }) => {
    const renderMarketingBrands = () => {
        if (!brand.marketingBrands || brand.marketingBrands.length === 0) {
            return '-';
        }

        return brand.marketingBrands.map((mb, index) => (
            <span key={mb.id || index}>
                {mb.name}
                {index < brand.marketingBrands!.length - 1 && ', '}
            </span>
        ));
    };

    return (
        <SectionCard title="Status Information">
            <Flex direction="row" gap="4">
                <Flex direction="column" gap="4">
                    <LabelText>Status</LabelText>
                    <LabelText>Message</LabelText>
                    <LabelText>ID</LabelText>
                    <LabelText>Attached Marketing Brands</LabelText>
                    <LabelText>Created On</LabelText>
                    <LabelText>Modified On</LabelText>
                    <LabelText>Submitted On</LabelText>
                    <LabelText>Scored On</LabelText>
                </Flex>

                <Flex direction="column" gap="4">
                    <FieldText>{getTelecomBrandStatusDisplayName(brand.status)}</FieldText>
                    <FieldText>{brand.message || '-'}</FieldText>
                    <FieldText>{brand.id || '-'}</FieldText>
                    <FieldText>{renderMarketingBrands()}</FieldText>
                    <FieldText>{formatTelecomDateWithTimezone(brand.createdOn)}</FieldText>
                    <FieldText>{formatTelecomDateWithTimezone(brand.modifiedOn)}</FieldText>
                    <FieldText>
                        {brand.submittedOn ? formatTelecomDateWithTimezone(brand.submittedOn) : '-'}
                    </FieldText>
                    <FieldText>
                        {brand.scoredOn ? formatTelecomDateWithTimezone(brand.scoredOn) : '-'}
                    </FieldText>
                </Flex>
            </Flex>
        </SectionCard>
    );
};
